var _mask, _g, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSurgicalgloves = function SvgSurgicalgloves(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "surgicalgloves_svg__a",
    width: 14,
    height: 5,
    x: 14,
    y: 29,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M14.374 29.895h13.38v4.104h-13.38z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#surgicalgloves_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4B4B4B",
    fillRule: "evenodd",
    d: "M27.754 29.895v4.104H16.577a2.203 2.203 0 0 1-2.203-2.202v-1.902z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E2E2E2",
    fillRule: "evenodd",
    d: "M30.899 16.294a2.32 2.32 0 0 0-2.84 1.64l-.22.974h-.085V8.84c0-.928-.758-1.688-1.687-1.688h-.244c-.538 0-1.014.26-1.323.654V7.79c0-.928-.759-1.687-1.687-1.687h-.244c-.928 0-1.687.76-1.687 1.687v.705a1.68 1.68 0 0 0-1.324-.655h-.243c-.927 0-1.687.76-1.687 1.688v2.727a1.68 1.68 0 0 0-1.323-.654h-.244c-.928 0-1.687.759-1.687 1.687v16.607h12.675a3.764 3.764 0 0 0 3.677-2.961h.082l1.73-7.8a2.32 2.32 0 0 0-1.64-2.84",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF773D",
    fillRule: "evenodd",
    d: "M21.244 25.792v4.103H10.066a2.2 2.2 0 0 1-2.203-2.202v-1.901z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    fillRule: "evenodd",
    d: "M19.557 7.498h-.244c-.537 0-1.014.26-1.323.654V5.424c0-.928-.76-1.687-1.687-1.687h-.245a1.68 1.68 0 0 0-1.322.655v-.705c0-.928-.76-1.687-1.687-1.687h-.244c-.928 0-1.688.759-1.688 1.687v.017a1.68 1.68 0 0 0-1.322-.655H9.55c-.928 0-1.687.76-1.687 1.686v10.071h-.086l-.22-.976a2.318 2.318 0 1 0-4.48 1.2l1.731 7.8h.083a3.765 3.765 0 0 0 3.676 2.961h12.676V9.184c0-.927-.76-1.686-1.687-1.686",
    clipRule: "evenodd"
  })));
};
export default SvgSurgicalgloves;